import dashboardService from '../services/dashboard.service.js'

const getDefaultState = () => {
  return {
    annualRevenue: [],
    chartData: {
      labels: [],
      datasets: []
    },
    ytdRevenue: {
      year: null,
      revenue: 0,
      target: 0,
      percent: 0
    }
  }
}

export const dashboard = {
  namespaced: true,

  state: getDefaultState(),

  actions: {
    fetchRevenueProfitChartData({ commit }) {
      return dashboardService.getAnnualRevenueProfit().then(
        (response) => {
          commit('fetchRevenueSuccess', response)
          return Promise.resolve(response)
        },
        (error) => {
          commit('fetchRevenueFailure')
          return Promise.reject(error)
        }
      )
    },
    fetchYTDRevenueTarget({ commit }, year) {
      return dashboardService.getRevenueTarget(year).then(
        (response) => {
          commit('fetchYTDRevenueSuccess', response)
          return response
        },
        (error) => {
          commit('fetchYTDRevenueFailure')
          return Promise.reject(error)
        }
      )
    }
  },

  mutations: {
    fetchRevenueSuccess(state, response) {
      const rows = Array.isArray(response) ? response : response.data || [];

      const labels = rows.map(item => item.year);
      const revenues = rows.map(item => item.revenue);
      const profits = rows.map(item => item.profit);

      state.chartData = {
        labels,
        datasets: [
          {
            type: 'bar',
            label: 'Profit',
            data: profits,
            backgroundColor: '#fbbf24',
            borderRadius: 6,
            barThickness: 32,
            order: 2
          },
          {
            type: 'line',
            label: 'Revenue',
            data: revenues,
            borderColor: '#6366f1',
            backgroundColor: '#6366f1',
            tension: 0.35,
            pointRadius: 4,
            pointBackgroundColor: '#ffffff',
            pointBorderColor: '#6366f1',
            pointBorderWidth: 2,
            fill: false,
            order: 1
          }
        ]
      };
    },
    fetchRevenueFailure(state) {
      state.chartData = {
        labels: [],
        datasets: []
      }
    },
    fetchYTDRevenueSuccess(state, payload) {
      state.ytdRevenue = {
        year: payload.year,
        revenue: payload.actual_revenue,
        target: payload.target_revenue,
        percent: Math.round(payload.percent)
      }
    },

    fetchYTDRevenueFailure(state) {
      state.ytdRevenue = {
        year: null,
        revenue: 0,
        target: 0,
        percent: 0
      }
    }
  },

  getters: {
    // Annual Revenue & Profit Chart Data
    chartData: (state) => state.chartData,
    
    // YTD Revenue
    ytdRevenuePercent: (state) => state.ytdRevenue.percent,
    ytdRevenueActual: (state) => state.ytdRevenue.revenue,
    ytdRevenueTarget: (state) => state.ytdRevenue.target,
    ytdRevenueDetail: (state) => state.ytdRevenue
  }
}